module.exports = __webpack_public_path__ + "static/img/11ko.20d1079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/11ko.jpg
// module id = ciWU
// module chunks = 0